module.exports = __webpack_public_path__ + "static/media/01.c01081ff.png";